import { render, staticRenderFns } from "./ArticleListView.vue?vue&type=template&id=56703a00&"
import script from "./ArticleListView.vue?vue&type=script&lang=js&"
export * from "./ArticleListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports